import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/images/banner-bisa-belanja-popup.webp'


const _hoisted_1 = {
  style: {"max-height":"80vh","width":"90vw"},
  class: "relative bg-white text-gray-lp-300 max-w-full flex-col justify-between flex rounded-2xl"
}
const _hoisted_2 = { class: "flex flex-no-wrap" }
const _hoisted_3 = {
  style: {"border-radius":"1rem 0 0 1rem","width":"30%"},
  class: "bg-gray-lp-200 mx-auto pb-6 pt-12 flex flex-col justify-between"
}
const _hoisted_4 = { class: "flex flex-wrap justify-center" }
const _hoisted_5 = {
  style: {"width":"70%"},
  class: "relative"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-between w-full border-b border-gray-lp-400" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-20px font-semibold px-6 py-4" }, " Program Affiliate ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "p-6 text-black-lp-300" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "w-full h-auto",
    alt: "banner-bisa-belanja"
  }),
  /*#__PURE__*/_createVNode("div", { class: "font-bold text-14px mt-6" }, [
    /*#__PURE__*/_createTextVNode(" Dapatkan Komisi dengan mengajak pelanggan Anda belanja di "),
    /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300" }, "BisaBelanja"),
    /*#__PURE__*/_createTextVNode(" dengan cara : ")
  ]),
  /*#__PURE__*/_createVNode("ul", { class: "list-disc px-8 mt-3 font-normal space-y-1 text-14px" }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" Lion Parcel Agent membagikan "),
      /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "link toko"),
      /*#__PURE__*/_createTextVNode(" kemitraannya kepada pelanggan ")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("span", { class: "font-bold" }, "Link toko"),
      /*#__PURE__*/_createTextVNode(" akan masuk ke website dan dapat diakses oleh pelanggan ")
    ]),
    /*#__PURE__*/_createVNode("li", null, " Pelanggan melakukan login / signup untuk memesan produk "),
    /*#__PURE__*/_createVNode("li", null, " Pelanggan melakukan check out dan melakukan pembayaran sesuai metode pembayaran yang tersedia "),
    /*#__PURE__*/_createVNode("li", null, " Barang dikirim oleh Lion parcel dan diterima oleh pelanggan "),
    /*#__PURE__*/_createVNode("li", null, " POS mendapatkan komisi yang akan diberikan ke dalam saldo genesis ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActiveQR = _resolveComponent("ActiveQR")!
  const _component_InActiveQR = _resolveComponent("InActiveQR")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        ref: "modal",
        tabindex: "0",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["esc"])),
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"])),
        class: "justify-center items-center flex bg-overlay fixed inset-0 z-50 overflow-hidden"
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.qrCode,
                  class: `w-1/2 mb-6 mt-0 ${_ctx.expiredAt && 'opacity-50'}`,
                  alt: "qrcode-referral"
                }, null, 10, ["src"])
              ]),
              (!_ctx.expiredAt)
                ? (_openBlock(), _createBlock(_component_ActiveQR, {
                    key: 0,
                    link: _ctx.link
                  }, null, 8, ["link"]))
                : (_openBlock(), _createBlock(_component_InActiveQR, {
                    key: 1,
                    expiredAt: _ctx.expiredAt
                  }, null, 8, ["expiredAt"]))
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: _imports_0,
                class: "w-6 cursor-pointer absolute",
                style: {"top":"1rem","right":"1.5rem"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                alt: "x"
              }),
              _hoisted_6,
              _hoisted_7
            ])
          ])
        ])
      ], 544))
    : _createCommentVNode("", true)
}